import { render, staticRenderFns } from "./AssistantMessageFeedback.vue?vue&type=template&id=b2497014&scoped=true"
import script from "./AssistantMessageFeedback.vue?vue&type=script&lang=js"
export * from "./AssistantMessageFeedback.vue?vue&type=script&lang=js"
import style0 from "./AssistantMessageFeedback.vue?vue&type=style&index=0&id=b2497014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2497014",
  null
  
)

export default component.exports